import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=642d4575"
import script from "./LayoutDefault.vue?vue&type=script&lang=ts"
export * from "./LayoutDefault.vue?vue&type=script&lang=ts"
import style0 from "./LayoutDefault.vue?vue&type=style&index=0&id=642d4575&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports